<template>
  <span>

    <v-btn
      dark
      fab
      absolute
      bottom
      right
      color="blue"
      class="btn-float-help"
      @click="contactDialog = true">
      <v-icon>mdi-help</v-icon>
    </v-btn>
    <v-dialog
      width="800"
      v-model="contactDialog"
      persistent>

    <v-card>
      <v-card-title class="headline teal darken-4 white--text" primary-title>
        Ajuda
      </v-card-title>

      <v-card-text>
        Visando uma melhoria na comunicação e atendimento unificado, para entrar em contato
        conosco, basta enviar uma mensagem para o nosso WhatsApp <a
        href="https://api.whatsapp.com/send?1=pt_BR&phone=5582988339407" target="_blank">(82) 98833-9407</a>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click="contactDialog = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </span>
</template>

<script>
export default {
  name: 'ContactComponent',
  data() {
    return {
      contactDialog: false,
    };
  },
  methods: {
    agreeWithTerms() {
      this.$store.dispatch('acceptLegalTerms')
        .then(() => {
          this.$store.dispatch('getCurrentUser');
        });
    },
  },
};
</script>
<style scoped>
  .btn-float-help{
    bottom: 10px !important;
    position: fixed;
  }
</style>
